import './Layout.css'
import React, { Component } from 'react'

export default class Layout extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="content-top-banner">
          <a href="/">
            <img
              src="https://storage.googleapis.com/slite-cdn/logos/slite/grey.svg"
              height="24"
              alt="slite"
            />
          </a>
        </div>
        <div className="content-layout slite-design-system scroll-y height-full-page">
          {this.props.children}
        </div>
      </React.Fragment>
    )
  }
}
